module.exports = __webpack_public_path__ + "img/gyny-active.ab738e3e.svg";